// I18N_START
const TRANSLATIONS = {
  en: {
    congrats: "Congratulations!",
    level: "Level {n}",
    tap_to_continue: "Tap to continue",
    try_again: "Try Again",
    resume: "Resume",
    restart_game: "Restart",
    to_hub: "Home",
  },
  hi: {
    congrats: "बधाई हो!",
    level: "स्तर {n}",
    tap_to_continue: "जारी रखने के लिए टैप करें",
    try_again: "फिर कोशिश करें",
    resume: "जारी रखें",
    restart_game: "फिर से",
    to_hub: "मुख्य",
  },
  ru: {
    congrats: "Поздравляю!",
    level: "Уровень {n}",
    tap_to_continue: "Нажми чтобы продолжить",
    try_again: "Попробуй ещё раз",
    resume: "Продолжить",
    restart_game: "Заново",
    to_hub: "В хаб",
  },
} as const;
// I18N_END

type Lang = keyof typeof TRANSLATIONS;
type Key  = keyof typeof TRANSLATIONS['ru'];
type Params = Record<string, string | number>;

const _lang = (localStorage.getItem('lang') ?? navigator.language.slice(0, 2)) as Lang;
const _L    = TRANSLATIONS[_lang in TRANSLATIONS ? _lang : 'ru'];

export function t(key: Key, params?: Params): string {
  let s: string = _L[key] ?? TRANSLATIONS['ru'][key];
  if (params) for (const k in params) s = s.replace(`{${k}}`, String(params[k]));
  return s;
}
